/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Image from 'components_library/atoms/Image/Image';
import { getImageFromImageObject } from 'components_library/utils/imageUtils';
import Link from 'components_library/atoms/Link/Link';
import LiveBarIcon from 'components_library/atoms/LiveBarIcon/LiveBarIcon';
import analyticsWrapper from 'components_library/utils/analyticsWrapper';
import { convertHtmlToStringText } from 'utils/common';
import classNames from 'classnames';
import Icon from './Icon';
import s from './StoryCard.scss';
import Ctawithimage from '../../../components_v2/desktop/CTA_with_image/Ctawithimage';
import InViewObserver from '../../../components/InViewObserver/InViewObserver';

const defaultCardLayoyt = 'card_4';
const supportedCardLayouts = [
  'card_1',
  'card_2',
  'card_3',
  'card_4',
  'card_5',
  'card_6',
  'card_7',
  'card_8',
  'card_9',
  'card_10',
  'card_11',
  'card_12',
  'card_13',
  'card_14',
  // 'card_15',
  'card_16',
  'card_17',
  'card_18',
  'card_19',
];
function customOnError(e) {
  e.target.onerror = null;
  e.target.src = 'https://static.toiimg.com/photo/25581306.cms';
}

function Card(props) {
  const {
    data = {},
    showDuration,
    showPhotosCount,
    onClick,
    htmlKeys,
    shouldNotlazyloadImage,
    isMobile,
    ga,
    index,
    hideTimeStamp = false,
  } = props;

  let { layout: cardType } = props;
  if (supportedCardLayouts.indexOf(cardType) < 0) {
    cardType = defaultCardLayoyt;
  }

  const onCardClick = event => {
    if (onClick && typeof onClick === 'function') {
      onClick(event);
    }

    if (ga && ga.type) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: ga.type,
        category: 'story_click',
        label: data?.wu,
        story_no: index,
        msid: data?.id,
      });
    }
  };

  // Flags for hiding data
  const hideImage =
    cardType === 'card_2' || cardType === 'card_14' || cardType === 'card_16';
  const showDescription = cardType === 'card_1' || cardType === 'card_2';
  const showByline =
    cardType === 'card_1' ||
    cardType === 'card_2' ||
    cardType === 'card_3' ||
    cardType === 'card_8' ||
    cardType === 'card_13';

  // Image Classes
  const imageWrapperClass = classNames({
    [s.large]:
      cardType === 'card_1' || cardType === 'card_4' || cardType === 'card_6',
    [s.medium]: cardType === 'card_3',
    [s.small]:
      cardType === 'card_5' || cardType === 'card_7' || cardType === 'card_8',
  });

  // Heading Classes
  const headingWrapperClass = classNames({
    // 11
    [s.fs_10]: cardType === 'card_16',
    [s.fs_13]:
      cardType === 'card_4' || cardType === 'card_5' || cardType === 'card_14',
    [s.fs_16]:
      // cardType === 'card_1' ||
      cardType === 'card_2' ||
      cardType === 'card_3' ||
      cardType === 'card_6' ||
      cardType === 'card_7' ||
      cardType === 'card_8' ||
      cardType === 'card_13' ||
      cardType === 'card_12' ||
      cardType === 'card_17',
    [s.fs_14]: cardType === 'card_10' || cardType === 'card_15',
    [s.fs_24]: cardType === 'card_1',
    //[s.fs_18]: cardType === 'card_6',

    // 4, 5, 9, 11, 14
    [s.lh_16]: cardType === 'card_16',
    [s.lh_18]: cardType === 'card_4',
    [s.lh_20]:
      cardType === 'card_6' ||
      cardType === 'card_' ||
      cardType === 'card_10' ||
      cardType === 'card_12' ||
      cardType === 'card_15' ||
      cardType === 'card_17',
    [s.lh_24]:
      cardType === 'card_1' ||
      cardType === 'card_2' ||
      cardType === 'card_3' ||
      cardType === 'card_7' ||
      cardType === 'card_8' ||
      cardType === 'card_13',
    [s.lh_32]: cardType === 'card_1',

    // 11
    [s.fw_500]:
      cardType === 'card_3' ||
      cardType === 'card_4' ||
      cardType === 'card_5' ||
      cardType === 'card_12' ||
      cardType === 'card_15' ||
      cardType === 'card_14' ||
      cardType === 'card_16' ||
      cardType === 'card_17',
    [s.fw_600]:
      cardType === 'card_7' || cardType === 'card_8' || cardType === 'card_10',
    [s.fw_700]:
      cardType === 'card_1' ||
      cardType === 'card_2' ||
      cardType === 'card_13' ||
      cardType === 'card_6',

    // [s.f_weight]:
    //   cardType === 'card_3' ||
    //   cardType === 'card_4' ||
    //   cardType === 'card_5' ||
    //   cardType === 'card_12' ||
    //   cardType === 'card_15' ||
    //   cardType === 'card_14',
    [s.lc_2]: cardType === 'card_3' || cardType === 'card_5',
    [s.lc_3]:
      cardType === 'card_2' ||
      cardType === 'card_4' ||
      cardType === 'card_10' ||
      cardType === 'card_7' ||
      cardType === 'card_13' ||
      cardType === 'card_15',
    [s.lc_1]: cardType === 'card_14' || cardType === 'card_16',
  });

  const wrapperClass = classNames({
    [s.card_1]: cardType === 'card_1',
    [s.card_2]: cardType === 'card_2',
    [s.card_3]: cardType === 'card_3',
    [s.card_4]: cardType === 'card_4',
    [s.card_5]: cardType === 'card_5',
    [s.card_6]: cardType === 'card_6',
    [s.card_7]: cardType === 'card_7',
    [s.card_8]: cardType === 'card_8',
    [s.card_9]: cardType === 'card_9',
    [s.card_10]: cardType === 'card_10',
    [s.card_11]: cardType === 'card_11',
    [s.card_12]: cardType === 'card_12',
    [s.card_13]: cardType === 'card_13',
    [s.card_14]: cardType === 'card_14',
    // [s.card_15]: cardType === 'card_15',
    [s.card_16]: cardType === 'card_16',
    [s.card_17]: cardType === 'card_17',
    [s.card_18]: cardType === 'card_18',
    [s.card_19]: cardType === 'card_19',
  });

  const { imgWidth = isMobile ? '375' : '600' } = props;
  const { imageid = '', imagesize, du: duration, imageUrl } = data;

  const photosCount = data.photosCount || data.imgcount;
  const { image = {} } = data;
  image.width = imgWidth;
  image.id = imageid || image.id;
  image.version = imagesize || image.version || '123456';

  const imageSrc = getImageFromImageObject(image, isMobile) || imageUrl;
  const { target } = props;

  const isTypeVideo =
    data.hasVideo ||
    data.hasvideo ||
    data.type === 'video' ||
    data.tn === 'video';
  const isPhotoStory = data.type === 'photostory' || data.tn === 'photostory';
  const isToiPlusStory = data.cs === 'prime';
  const isVisualStoryCard =
    cardType === 'card_12' || cardType === 'card_15' || cardType === 'card_17';
  const isIconNeeded =
    isPhotoStory || isTypeVideo || isToiPlusStory || isVisualStoryCard;
  const isIconInOverlay = cardType === 'card_6';
  const isIconSmall =
    cardType === 'card_7' ||
    cardType === 'card_8' ||
    cardType === 'card_10' ||
    cardType === 'card_5';

  let headingTxt = data.hl;
  if (htmlKeys && htmlKeys instanceof Array && htmlKeys.indexOf('hl') > -1) {
    headingTxt = convertHtmlToStringText(data.hl);
  }

  let descTxt = data.des || data.syn;
  if (htmlKeys && htmlKeys instanceof Array && htmlKeys.indexOf('des') > -1) {
    descTxt = convertHtmlToStringText(data.des || data.syn);
  }
  descTxt = descTxt || '';
  const shouldShowDescription =
    showDescription && typeof descTxt === 'string' && descTxt !== '';

  let _target = target ? '_blank' : '';

  if (data.target && data.target === '_blank') {
    _target = data.target;
  }

  if (data?.type === 'cta_with_image') {
    return (
      <InViewObserver
        inViewCallback={() => {
          analyticsWrapper('ga4', {
            event: 'user_shown',
            type: data?.id || 'cta_with_image',
            category: data?.secname || 'listing',
          });
        }}
      >
        <Ctawithimage data={data} />
      </InViewObserver>
    );
  }

  return (
    <Link
      to={data.wu}
      onClick={onCardClick}
      doNotChangeURL={props.doNotChangeURL}
      target={_target}
      rel={data.rel}
      key={data.id}
      data-videomsid={data.id}
      className={`${s.storyCard} ${wrapperClass}  ${cardType}`}
    >
      {/* ${s.storycaroverlay}  */}
      {imageSrc &&
        !hideImage && (
          <div className={`${s.scImgBlock} ${imageWrapperClass}`}>
            <div className={s.scImgWrap}>
              {/* Class for image size  needs to be add on above div */}
              <Image
                key={data.id}
                width={imgWidth}
                src={imageSrc}
                //placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
                alt={headingTxt}
                altTitle={headingTxt}
                lazyload={!shouldNotlazyloadImage}
                onError={customOnError}
                offsetVertical={300}
                className={s.story_img}
              />
              {data.type === 'liveblog' && cardType === 'card_6' ? (
                <span className={s.liveIconWrapper}>
                  <LiveBarIcon />
                </span>
              ) : null}
            </div>

            {isIconNeeded &&
              !isIconInOverlay &&
              Icon(
                isPhotoStory,
                isTypeVideo,
                showDuration && duration,
                showPhotosCount && photosCount,
                isVisualStoryCard,
                isToiPlusStory,
                isIconSmall,
              )}
          </div>
        )}
      <div className={s.scContentContainer}>
        {data.type === 'liveblog' ? (
          <div className={`${s.liveBtn} ${s.red}`} />
        ) : null}

        {(data.secname || data.dl) &&
          !hideTimeStamp &&
          showByline && (
            <div className={s.by_line}>
              {data.secname && (
                <span className={`${s.card_sec_name}`}>{data.secname}</span>
              )}{' '}
              {data.dl && `/`}
              {data.dl && <span className={`${s.dateformat}`}> {data.dl}</span>}
            </div>
          )}

        {isIconNeeded &&
          isIconInOverlay &&
          Icon(
            isPhotoStory,
            isTypeVideo,
            showDuration && duration,
            showPhotosCount && photosCount,
            isVisualStoryCard,
            isToiPlusStory,
            isIconSmall,
          )}

        <div className={`${s.card_heading} ${headingWrapperClass} `}>
          {headingTxt}
        </div>
        {shouldShowDescription &&
          descTxt &&
          descTxt !== 'null' && <p className={s.description}>{descTxt}</p>}
      </div>
    </Link>
  );
}
const mapStateToProps = (state, props) => ({
  isMobile: state.isMobile,
  imgWidth: props.imgWidth || (state.isMobile ? '375' : '600'),
});
Card.propTypes = {
  data: PropTypes.shape({}).isRequired,
  onClick: PropTypes.func,
  htmlKeys: PropTypes.arrayOf(PropTypes.string),
  shouldNotlazyloadImage: PropTypes.bool,
  imgWidth: PropTypes.string,
  doNotChangeURL: PropTypes.bool,
  target: PropTypes.bool,
  showDuration: PropTypes.bool,
  showPhotosCount: PropTypes.bool,
  restProps: PropTypes.shape({}),
  isMobile: PropTypes.bool,
  layout: PropTypes.string,
  ga: PropTypes.shape({}),
  index: PropTypes.number,
  hideTimeStamp: PropTypes.bool,
};
Card.defaultProps = {
  onClick: undefined,
  htmlKeys: [],
  shouldNotlazyloadImage: false,
  imgWidth: '',
  doNotChangeURL: false,
  target: false,
  showDuration: true,
  showPhotosCount: true,
  restProps: {},
  isMobile: false,
  layout: defaultCardLayoyt,
  ga: undefined,
  index: 0,
  hideTimeStamp: false,
};

export default connect(mapStateToProps)(React.memo(Card));
